module.exports = __webpack_public_path__ + "img/16_2.54fffc15.png";